
export default function TeamSection() {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Dark background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#1a1a1a] via-black to-[#0f0f0f]"></div>
      
      {/* Atmospheric lighting */}
      <div className="absolute top-1/3 left-1/4 w-[400px] h-[400px] bg-[#F6B766]/6 rounded-full blur-[100px]"></div>
      <div className="absolute bottom-1/3 right-1/4 w-[400px] h-[400px] bg-[#F4A259]/4 rounded-full blur-[100px]"></div>

      <div className="relative z-10 container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center mb-6">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-[#F6B766]/50"></div>
            <span className="mx-4 text-[#F6B766]/70 text-sm tracking-[0.3em] uppercase">Team</span>
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-[#F6B766]/50"></div>
          </div>
          
          <h2 className="text-5xl lg:text-6xl font-light text-white mb-6">
            The <span className="text-[#F6B766]">Pawnshop Broker</span>
          </h2>
          <p className="text-xl text-white/60 max-w-3xl mx-auto font-light leading-relaxed">
            전당포 골목의 숨은 고수, 게임을 세계로 퍼뜨리는 전략가
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-sm border border-white/10 rounded-3xl p-12 text-center">
            {/* Profile Image */}
            <div className="relative w-48 h-48 mx-auto mb-8">
              <div className="absolute inset-0 bg-gradient-to-br from-[#F6B766]/20 to-[#F4A259]/20 rounded-full blur-xl"></div>
              <img
                src="https://static.readdy.ai/image/fc3c8cf43f99dce665e9eef96771b375/9e7aaa02c00ef514e0c27270b7317a9f.png"
                alt="Haddon Kim"
                className="relative w-full h-full object-cover rounded-full border-4 border-[#F6B766]/30"
              />
            </div>

            {/* Name and Title */}
            <h3 className="text-4xl font-light text-white mb-2">Haddon Kim</h3>
            <p className="text-[#F6B766] text-xl mb-8 font-light">Creative Director</p>

            {/* Bio */}
            <div className="max-w-2xl mx-auto space-y-6 text-white/70 leading-relaxed">
              <p className="text-lg font-light">
                서울의 어두운 골목에서 시작된 MondayPawn의 창립자. 게임이 단순한 엔터테인먼트를 넘어 
                전세계 문화로 확산되는 과정을 설계합니다.
              </p>
              
              <p className="font-light">
                "소문은 가장 강력한 마케팅입니다. 우리는 게임이 자연스럽게 퍼져나갈 수 있는 
                환경을 만들고, 플레이어들이 스스로 이야기하고 싶어하는 콘텐츠를 창조합니다."
              </p>
            </div>

            {/* Contact */}
            <div className="mt-12 pt-8 border-t border-white/10">
              <a
                href="mailto:haddon@mondaypawn.com"
                className="inline-flex items-center text-[#F6B766] hover:text-[#F4A259] transition-colors font-light"
              >
                <i className="ri-mail-line mr-2"></i>
                haddon@mondaypawn.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
